import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FactCheckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fact_check"}/>
}
